/* Studio Huske custom JS - footer accordion fix */
document.addEventListener('DOMContentLoaded', function() {
  var triggers = document.querySelectorAll('.has-accordion [data-accordion-trigger]');
  triggers.forEach(function(trigger) {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      var parent = trigger.closest('.has-accordion');
      if (parent) {
        parent.classList.toggle('is-open');
      }
    });
  });
});


/* Testimonials - "Read more reviews" button (theme-update safe) */
document.addEventListener('DOMContentLoaded', function() {
  if (window.location.pathname !== '/') return;
  var section = document.querySelector('[data-pxu-testimonials]');
  if (!section) return;
  var container = section.querySelector('.pxu-testimonials__container');
  if (!container) return;
  var wrapper = document.createElement('div');
  wrapper.style.textAlign = 'center';
  wrapper.style.marginTop = '2rem';
  var btn = document.createElement('a');
  btn.href = '/pages/reviews';
  btn.className = 'button-primary';
  btn.textContent = 'Read more reviews';
  wrapper.appendChild(btn);
  container.appendChild(wrapper);
});

/* Before/after image wiper - fallback in case Empire's compiled JS doesn't
   initialise the component (known compatibility issue with pxu-before-after-image
   and Empire 12.3.0+). Drives --before-after-cursor-position directly. */
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.pxu-before-after-image__horizontal').forEach(function(el) {
    function setPos(x) {
      var rect = el.getBoundingClientRect();
      var pct = Math.min(100, Math.max(0, ((x - rect.left) / rect.width) * 100));
      el.style.setProperty('--before-after-cursor-position', pct + '%');
    }
    el.addEventListener('mousedown', function(e) {
      e.preventDefault();
      setPos(e.clientX);
      function onMove(e) { setPos(e.clientX); }
      function onUp() {
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onUp);
      }
      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', onUp);
    });
    el.addEventListener('touchstart', function(e) {
      function onMove(e) { setPos(e.touches[0].clientX); }
      function onEnd() {
        el.removeEventListener('touchmove', onMove);
        el.removeEventListener('touchend', onEnd);
      }
      el.addEventListener('touchmove', onMove);
      el.addEventListener('touchend', onEnd);
    }, { passive: true });
  });
});

/* Gift card recipient checkbox - sync details open with checkbox state.
   Browser quirk: clicking a form control inside <summary> prevents the
   native details toggle. Empire's JS was supposed to handle this but is broken.
   Fix: listen for checkbox change and manually toggle details. */
document.addEventListener('DOMContentLoaded', function() {
  var disclosure = document.querySelector('details.recipient-disclosure');
  if (!disclosure) return;
  var checkbox = disclosure.querySelector('.recipient-disclosure__checkbox');
  if (!checkbox) return;
  checkbox.addEventListener('change', function() {
    disclosure.open = checkbox.checked;
  });
  disclosure.addEventListener('toggle', function() {
    checkbox.checked = disclosure.open;
  });
});


/* === Newsletter cart nudge — click-delegated (avoids nested form issue) === */
document.addEventListener('click', function(e) {
  if (!e.target || e.target.id !== 'huske-nl-btn') return;
  var btn = e.target;
  var input = document.getElementById('huske-nl-email');
  if (!input) return;
  var email = input.value.trim();
  if (!email || !email.includes('@')) {
    input.focus();
    return;
  }
  var lang = (document.documentElement.lang || 'en').slice(0, 2);
  var label = btn.textContent;
  btn.disabled = true;
  btn.textContent = lang === 'de' ? 'Wird gesendet…' : lang === 'fr' ? 'Envoi…' : 'Sending…';
  /* 30 Oct 2026: same Klaviyo call as the blog box and /pages/hello, so signup_locale reaches the
     profile and French cart signups get the French Welcome Email 1. Answers 202 on success. */
  fetch('https://a.klaviyo.com/client/subscriptions/?company_id=W2K4PB', {
    method: 'POST',
    headers: {'Content-Type': 'application/json', 'revision': '2024-10-15'},
    body: JSON.stringify({ data: { type: 'subscription',
      attributes: { custom_source: 'Cart nudge',
        profile: { data: { type: 'profile', attributes: { email: email,
          properties: { signup_source: 'cart_nudge', signup_locale: lang } } } } },
      relationships: { list: { data: { type: 'list', id: 'YhwJih' } } } } })
  }).then(function(r) {
    if (!r.ok) throw new Error('subscribe failed');
    try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email }); } catch (x) {}
    /* 30 Oct 2026: list YhwJih triggers the Welcome Series, which sends FIRST10 (CHF 10 off).
       The old line promised a free shipping code. Copy Kate-approved 30 Oct. */
    var msg = lang === 'de' ? 'Danke. Dein Code für CHF 10 Rabatt ist unterwegs in dein Postfach.'
      : lang === 'fr' ? 'Merci. Ton code de CHF 10 de réduction arrive dans ta boîte mail.'
      : 'Thanks. Your CHF 10 code is on its way to your inbox.';
    var nudge = document.getElementById('huske-nl-nudge');
    if (nudge) nudge.innerHTML = '<p class="huske-newsletter-nudge__success">' + msg + '</p>';
  }).catch(function() {
    btn.disabled = false;
    btn.textContent = label;
  });
});


/* === Recently-viewed widget self-heal v1 ===
   Empire's recently-viewed widget reads handles from pxu-recentlyViewed-CHF-/{locale}
   localStorage and fetches /collections/all/products/{handle}?view=recently-viewed.
   When a product is unpublished, the fetch 404s and Empire logs noisily (verified
   via Playwright localStorage injection 1 May 2026; 1 unpublished handle = 4 console
   errors). This fetches the published product list and removes stale handles.
   Self-healing: each customer's storage cleaned on next visit. Idempotent. */
(function() {
  try {
    var KEY_PREFIX = 'pxu-recentlyViewed-CHF-';
    var keys = [];
    for (var i = 0; i < localStorage.length; i++) {
      var k = localStorage.key(i);
      if (k && k.indexOf(KEY_PREFIX) === 0) keys.push(k);
    }
    if (!keys.length) return;
    fetch('/products.json?limit=250', { credentials: 'omit' })
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(data) {
        if (!data || !data.products) return;
        var valid = {};
        data.products.forEach(function(p) { valid[p.handle] = true; });
        keys.forEach(function(k) {
          try {
            var raw = localStorage.getItem(k);
            if (!raw) return;
            var entries = JSON.parse(raw);
            if (!Array.isArray(entries)) return;
            var cleaned = entries.filter(function(e) {
              return e && e.handle && valid[e.handle];
            });
            if (cleaned.length !== entries.length) {
              localStorage.setItem(k, JSON.stringify(cleaned));
            }
          } catch (err) { /* malformed entry; leave alone */ }
        });
      })
      .catch(function() { /* network failure; skip cleanup */ });
  } catch (err) { /* never throw from this snippet */ }
})();
